import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { Button } from '@opswat/ui';
import { useGTM } from 'hooks/useGTM';
import notFound from 'images/404.png';

export const NotFound = ({ message }: { message?: string }) => {
    const { t } = useTranslation();
    const { trackClick } = useGTM();
    return (
        <div className='tw:flex tw:flex-col tw:justify-center tw:items-center tw:w-full tw:h-full tw-m-auto'>
            <img src={notFound} draggable={false} alt={t('Not found icon')} className='cm-float-404' />
            <div className='tw:flex tw:flex-col tw:gap-32 tw:justify-between'>
                <div className='tw:md:w-580 tw:px-10 tw:flex tw:flex-col tw:gap-9 tw:justify-between tw:text-center'>
                    {message ? (
                        <span className='tw:text-headline'>{message}</span>
                    ) : (
                        <span className='tw:text-headline'>{t('Page Not Found')}</span>
                    )}
                    <span className='tw:text-body tw:text-neutrals-800 tw:dark:text-neutrals-500'>
                        {message
                            ? t('The resource you are looking for does not exist.')
                            : t('The page you are looking for does not exist.')}
                    </span>
                </div>
                <Link to='/' className='tw:m-auto'>
                    <Button
                        variant='primary'
                        className='tw:font-medium tw:px-8'
                        text={t('Back to Home')}
                        onClick={() => trackClick('error-page-back-to-home-button')}
                    />
                </Link>
            </div>
        </div>
    );
};
